export function configureChartTimeAxis(axis, formatDate) {
  if (axis.__intradayLabelsConfigured) return;
  axis.__intradayLabelsConfigured = true;
  axis.setAll({
    dateFormats: { ...axis.get('dateFormats'), minute: 'HH:mm', hour: 'HH:mm', day: 'MMM dd' },
    // A minute grid changes its parent unit every hour, not only at midnight.
    periodChangeDateFormats: { ...axis.get('periodChangeDateFormats'), minute: 'HH:mm', hour: '[bold]MMM dd', day: '[bold]MMM dd' },
  });
  axis.get('renderer').labels.template.adapters.add('text', (text, label) => {
    const value = label.dataItem?.get('value');
    if (text !== '00:00' || !Number.isFinite(value)) return text;
    // Timezone conversion in amCharts expects a Date, not an epoch number.
    const date = new Date(value);
    return Number.isFinite(date.getTime()) ? formatDate(date, '[bold]MMM dd') : text;
  });
}

export function indicatorNumberFormat(currentFormat) {
  // Keep explicit units (including literal percentages), remove abbreviation,
  // and allow precision without padding every value with trailing zeroes.
  return (currentFormat || '#.###').replace(/[#0][#0,]*(?:\.[#0]+)?a?/, '#,###.########');
}

export function minimumPanelHeight({ isPricePanel, header = 0, footer = 0, padding = 0 }) {
  const plot = isPricePanel ? 120 : 64;
  return Math.ceil(plot + Math.max(0, header) + Math.max(0, footer) + Math.max(0, padding));
}

export function fitPanelHeights(available, panels) {
  const result = panels.map(panel => panel.minimum);
  if (result.reduce((sum, value) => sum + value, 0) >= available) return result;
  let remaining = available;
  let active = panels.map((panel, index) => ({ ...panel, index, weight: Math.max(0.0001, panel.weight || 1) }));
  while (active.length) {
    const totalWeight = active.reduce((sum, panel) => sum + panel.weight, 0);
    const constrained = active.filter(panel => remaining * panel.weight / totalWeight < panel.minimum);
    if (!constrained.length) {
      active.forEach(panel => { result[panel.index] = remaining * panel.weight / totalWeight; });
      break;
    }
    const frozen = new Set(constrained.map(panel => panel.index));
    constrained.forEach(panel => { remaining -= panel.minimum; });
    active = active.filter(panel => !frozen.has(panel.index));
  }
  return result;
}
